import { render, staticRenderFns } from "./EntityDetail.view.vue?vue&type=template&id=3ba81d7f&scoped=true&"
import script from "./EntityDetail.view.vue?vue&type=script&lang=ts&"
export * from "./EntityDetail.view.vue?vue&type=script&lang=ts&"
import style0 from "./EntityDetail.view.vue?vue&type=style&index=0&id=3ba81d7f&prod&lang=stylus&scoped=true&"
import style1 from "./EntityDetail.view.vue?vue&type=style&index=1&id=3ba81d7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba81d7f",
  null
  
)

export default component.exports